// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2lJV_","notes":"Notes_notes__3bKN-"};